import * as screenfull from 'screenfull';

const wait = (miliseconds) => new Promise((resolve) => setTimeout(resolve, miliseconds));

export default function createSwipeGallery(galleryId, galleryImages) {
    const images = galleryImages;
    const onSwipeCallbacks = [];
    const onNavigateClickCallbacks = [];
    const onFullscreenCallbacks = [];
    const prevImageHolder = $('.previousSlide figure');
    const currentImageHolder = $('.currentSlide figure');
    const nextImageHolder = $('.nextSlide figure');
    const previousSlide = $('.previousSlide');
    const currentSlide = $('.currentSlide');
    const nextSlide = $('.nextSlide');
    const gallery = $(galleryId);
    const totalImages = images.length;
    const count = images.length - 1;
    let current = 0;
    let slideWidth = $(window).width();
    const fsOpen = '#fullscreenOpen';
    let imageSize = 'thumb';
    const imageLarge = 'large';

    previousSlide.css('margin-left', -slideWidth);
    nextSlide.css('margin-right', -slideWidth);

    // učitavanje posljednje i druge slike
    setImages(prevImageHolder, count);

    if (current + 1 < count) {
        setImages(nextImageHolder, current + 1);
    }

    gallery.append('<div id="galleryNav"></div>');
    $('#galleryNav').append(`<span class="count">${(current + 1)}</span>`);
    $('#galleryNav').append(`<span class="counter">${totalImages}</span>`);

    setPrevNextButtons();

    const prev = $('.prevGalleryBtn');
    const next = $('.nextGalleryBtn');

    prevNextButtons();
    initFullsreenGallery();
    initResponsiveGallery();

    $(window).on('load resize', () => {
        currentImageHolder.find('img').css('top', imageYPosition);
    });

    gallery[0].addEventListener('swiperight', () => {
        slidingPrev();
        executeCallbacks(onSwipeCallbacks);
    });

    gallery[0].addEventListener('swipeleft', () => {
        slidingNext();
        executeCallbacks(onSwipeCallbacks);
    });

    gallery.on('click', '.prevGalleryBtn, .nextGalleryBtn', () => {
        executeCallbacks(onNavigateClickCallbacks);
    });

    $(document).on('click', 'figcaption', () => {
        currentSlide.find('h2, p').slideToggle();
    });

    function slidingNext() {
        setCurrentToNext();
        setCurrentFigure();
        currentSlide.addClass('left');
        wait(300).then(() => currentSlide.removeClass('left'));
        fullscreenNav();
        currentImageHolder.find('img')[0].onload = imageYPosition;
    }

    function slidingPrev() {
        setCurrentToPrevious();
        setCurrentFigure();
        currentSlide.addClass('right');
        wait(300).then(() => currentSlide.removeClass('right'));
        fullscreenNav();
        currentImageHolder.find('img')[0].onload = imageYPosition;
    }

    function setCurrentToPrevious() {
        current -= 1;

        if (current < 0) {
            current = count;
        }
    }

    function setCurrentToNext() {
        current += 1;

        if (current > count) {
            current = 0;
        }
    }

    // HTML <figure> sadrži sliku i figcaption (naslov i opis)
    function setCurrentFigure() {
        prevImageHolder.find('h2, p').remove();
        currentImageHolder.find('h2, p').remove();
        nextImageHolder.find('h2, p').remove();

        setImages(currentImageHolder, current);
        currentImageHolder.find('img')[0].onload = imageYPosition;

        // ne prikazujemo naslov slike koja ima opis, da se ne ponavlja
        if (images[current].description.length === 0) {
            currentImageHolder.children('figcaption').prepend(`<p>${images[current].title}</p>`);
        }
        currentImageHolder.children('figcaption').prepend(`<p>${images[current].description}</p>`);

        // učitavamo prethodnu i sljedeću sliku. nije potrebno provjeravati rubne slučajeve jer se prva i zadnja slika
        // učitaju odmah na početku
        if (current > 0) {
            setImages(prevImageHolder, current - 1);
        }

        if (current < count) {
            setImages(nextImageHolder, current + 1);
        }
    }

    function setImages(imageHolder, index) {
        imageHolder.find('a').attr('href', `${images[index][imageLarge]}`);
        imageHolder.find('img').attr({
            src: `${images[index][imageSize]}`,
            srcset: `${images[index][imageSize]} 1x, ${images[index][imageLarge]} 2x`,
            alt: `${images[index].alt}`,
        });

        if (gallery.hasClass('fullscreen')) {
            imageHolder.find('img').attr('srcset', '');
        }
    }

    function setPrevNextButtons() {
        gallery.prepend('<span class="prevGalleryBtn"></span>');
        gallery.append('<span class="nextGalleryBtn"></span>');
    }

    function prevNextButtons() {
        prev.on('click', () => {
            slidingPrev();
        });

        next.on('click', () => {
            slidingNext();
        });
    }

    function imageYPosition() {
        const imageHeight = currentImageHolder.find('img').height();
        const galleryHeight = currentImageHolder.height();
        const topPosition = (galleryHeight - imageHeight) / 2;

        currentImageHolder.find('img').css('top', topPosition);
    }

    function initFullsreenGallery() {
        $(document).on('click', fsOpen, (e) => {
            e.preventDefault();
            gallery.addClass('fullscreen')
                .prepend('<div id="fullscreenNav"></div><span class="fullscreenClose"></span>');
            $('#fullscreenNav').append(`<span class="counter">${totalImages}</span>`);
            $('#fullscreenNav').append(`<span class="count">${(current + 1)}</span>`);
            imageSize = 'large';
            setImages(currentImageHolder, current);
            browserGoFullscreen('.fullscreenClose');
            executeCallbacks(onFullscreenCallbacks);
        });

        const fsClose = '.fullscreenClose';
        const fsNav = '#fullscreenNav';

        $(document).on('click', fsClose, () => {
            gallery.removeClass('fullscreen');
            gallery.find(fsNav).remove();
            gallery.find(fsClose).remove();
            imageSize = 'thumb';
            setImages(currentImageHolder, current);
        });
    }

    function fullscreenNav() {
        if (gallery.has('.fullscreen')) {
            $('.count').html(current + 1);
        }
    }

    function browserGoFullscreen(exit) {
        if (screenfull.enabled) {
            screenfull.request();
            $(exit).on('click', () => {
                screenfull.exit();
            });
        }
    }

    // Prilikom promjene rezolucije, updejtaju se već postavljene margine u odnosu na širinu prozora
    function initResponsiveGallery() {
        $(window).on('resize orientationchange', function abc() {
            if ($(this).width() !== slideWidth) {
                slideWidth = $(this).width();
                currentSlide.css('margin-left', 0);
            }
        });
    }

    return {
        onSwipe(callback) {
            onSwipeCallbacks.push(callback);
        },
        onNavigateClick(callback) {
            onNavigateClickCallbacks.push(callback);
        },
        onFullscreen(callback) {
            onFullscreenCallbacks.push(callback);
        },
    };
}

function executeCallbacks(callbacks) {
    callbacks.map((callback) => callback());
}
